import AmericanSports from './_american-sports.js'
import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'
import EventListItemSkeleton from './_event-list-item-skeleton.js'

export default {
  name: 'EventListSkeleton',
  values: {
    numberOfEvents: 5,
    showMarketSwitcher: true,
    showEventListTitle: false,
    _desktop_showEventListTitle: true,
    numberOfMarkets: 1,
    _desktop_numberOfMarkets: 3,
    numberOfAmericanSportMarkets: 1,
    americanSports: {
      configSet: AmericanSports,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          flexDirection: 'column',
        },
        separator: {
          style: {
            size: '1px',
          },
        },
      },
    },
    eventListHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _desktop_justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '49px',
          _mobile_minHeight: '40px',
        },
      },
    },
    eventListTitle: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '104px',
          height: '16px',
          _desktop_width: '92px',
          _desktop_height: '14px',
        },
      },
    },
    marketSwitcherContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '8px 0',
          _desktop_padding: '4px 0',
          _desktop_flexGrow: 0,
          justifyContent: 'end',
        },
      },
    },
    marketSwitcher: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          minHeight: '40px',
          width: '100%',
          _desktop_minWidth: '176px',
          _desktop_minHeight: '30px',
          _mobile_maxWidth: '176px',
        },
      },
    },
    groupContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 0 ',
        },
      },
    },
    groupHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '46px',
        },
      },
    },
    eventsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        separator: {
          style: {
            size: '1px',
          },
        },
        style: {
          flexDirection: 'column',
        },
      },
    },
    typeAndClassContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
          padding: '4px 0 0 0',
        },
      },
    },
    type: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '92px',
          height: '14px',
        },
      },
    },
    class: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '44px',
          height: '14px',
        },
      },
    },
    groupHeaderMarketsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: 0,
        },
      },
    },
    groupHeaderMarketContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        _desktop_itemSpacing: '20px',
        style: {
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 0,
          _desktop_width: '168px',
          _desktop_padding: '0 4px',
        },
      },
    },
    selectionHeader: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '60px',
          height: '18px',
          _desktop_width: '100%',
          maxWidth: '88px',
        },
      },
    },
    event: {
      configSet: EventListItemSkeleton,
      configValues: {},
    },
    americanEvent: {
      configSet: EventListItemSkeleton,
      configValues: {
        isAmericanEvent: true,
      },
    },
    sortingEnabledContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          justifyContent: 'end',
        },
      },
    },
    marketSwitcherWhenSortingEnabled: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '176px',
          _mobile_width: '137px',
          height: '32px',
          _mobile_height: '17px',
        },
      },
    },
    sortingSelector: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '104px',
          _mobile_width: '80px',
          height: '16px',
          _mobile_height: '17px',
        },
      },
    },
    numberOfOutrightEvents: 4,
    outrightsSkeletonContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          flexDirection: 'column',
        },
        separator: {
          style: {
            size: '1px',
          },
        },
      },
    },
    line: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '51px',
        },
      },
    },
    outrightEvent: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '58%',
          maxWidth: '198px',
          _desktop_maxWidth: '400px',
          height: '14px',
        },
      },
    },
    markets: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '24%',
          maxWidth: '80px',
          height: '14px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
